module.exports = __webpack_public_path__ + "static/media/sgjobhunt.82e4ee94.png";